import { Navigate, Outlet, useParams } from "react-router";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import LoaderBox from "@entrilia/shared/components/LoaderBox";
import { pageRoutes } from "../../../routes";
import { DashboardContextProvider } from "./contexts/DashboardContextProvider";
import useDashboardState from "./hooks/useDashboardState";

const DashboardPage = () => {
  const { client } = useParams();
  const { id } = useParams();
  const dashboardState = useDashboardState(id ?? "");

  if (!id) {
    return <Navigate to={`/${client}/${pageRoutes.dashboards}`} />;
  }

  if (dashboardState.loading.inProgress || !dashboardState.dashboard) {
    return <LoaderBox loading={true} />;
  }

  if (dashboardState.loading.error) {
    return <DataLoadingFailed title="Failed to load dashboard" />;
  }

  if (dashboardState.updating.error) {
    return <DataLoadingFailed title="Failed to update dashboard" />;
  }
  return (
    <DashboardContextProvider {...dashboardState}>
      <Outlet />
    </DashboardContextProvider>
  );
};

export default DashboardPage;
